// Whether a Sight Reading tier on screen opens a new play session when the app
// comes back as a new sitting. A new session resets the count toward the next tier
// (the trainer reloads the tier), so it opens only while nothing is lost: the tier
// has a session, no phrase of it has been earned yet, and no wrap-up is loading or
// on screen. Otherwise the tier carries on in its session.
export type ResumedTierState = {
  playSessionId: string | null | undefined;
  levelNumber: number | undefined;
  phrasesTilNextTier: number;
  minPhrases: number;
  wrapUpPendingOrShown: boolean;
};

export const opensNewTierSessionOnResume = ({
  playSessionId,
  levelNumber,
  phrasesTilNextTier,
  minPhrases,
  wrapUpPendingOrShown,
}: ResumedTierState): boolean =>
  Boolean(playSessionId) &&
  levelNumber !== undefined &&
  !wrapUpPendingOrShown &&
  phrasesTilNextTier === minPhrases;
